var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEditReport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icEditReport") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M43.1284762,566 L39.4080317,562.5 L40.5,561.351821 C41.975746,560.1695 43.7290355,560.352376 44.5,561.351821 C45,562 45.5,563.457464 44.5,564.5 L43.1284762,566 Z M30.5,578.505393 L25.5,579.78575 L26.7010741,574.792857 L38,563.5 L42,567.165714 L30.5,578.505393 Z M39.3061649,560.164304 L25.5304373,573.940032 C25.399295,574.071174 25.3047954,574.237031 25.2604385,574.416387 L23.8101589,580.223291 C23.7233735,580.572361 23.8255874,580.942645 24.0801577,581.199144 C24.2749426,581.393929 24.5372272,581.5 24.8052975,581.5 C24.8882257,581.5 24.971154,581.490357 25.0540822,581.469143 L30.8629148,580.016935 C31.0441998,579.972578 31.2081277,579.878078 31.33927,579.746936 L45.1149976,565.971208 C45.89028,565.195926 46.3184211,564.164145 46.3184211,563.066792 C46.3184211,561.96944 45.8922086,560.939587 45.1149976,560.164304 C43.5644327,558.611811 40.8586584,558.611811 39.3061649,560.164304 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messenger-Inbox---Report-Options",
    transform: "translate(-23.000000, -559.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icEditReport",
    fill: "#333333",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditReport);
export default __webpack_public_path__ + "static/media/icEditReport.37e78a1c1a9c250479fedd4c940f7551.svg";
export { ForwardRef as ReactComponent };